// import React, { useState } from "react";
// import splash1 from "../assets/splashScreen/OBJECTS.svg";
// import splash2 from "../assets/splashScreen/Group 1.svg";
// import splash3 from "../assets/splashScreen/Group 2.svg";
// import blurTop from "../assets/splashScreen/Blur.svg"// ⬅ add your blur image

// const screens = [
//   {
//     img: splash1,
//     title: "Smarter Payments for a Smarter Life",
//     desc: "Pay bills instantly and securely. Simple, fast and reliable.",
//   },
//   {
//     img: splash2,
//     title: "Secure Digital Wallet",
//     desc: "Save your cards and make secure transactions anywhere.",
//   },
//   {
//     img: splash3,
//     title: "Pay. Track. Manage",
//     desc: "Keep full control of your spending with smart insights.",
//   },
// ];

// const OnboardingScreen = () => {
//   const [index, setIndex] = useState(0);

//   let touchStartX = 0;
//   let touchEndX = 0;

//   const handleTouchStart = (e) => {
//     touchStartX = e.touches[0].clientX;
//   };

//   const handleTouchEnd = (e) => {
//     touchEndX = e.changedTouches[0].clientX;
//     handleSwipe();
//   };

//   const handleSwipe = () => {
//     if (touchStartX - touchEndX > 50) {
//       if (index < screens.length - 1) setIndex(index + 1);
//     }
//     if (touchEndX - touchStartX > 50) {
//       if (index > 0) setIndex(index - 1);
//     }
//   };

//   return (
//     <div
//       className="relative w-full h-screen flex flex-col justify-between bg-white px-6 pt-8 pb-10 overflow-hidden"
//       onTouchStart={handleTouchStart}
//       onTouchEnd={handleTouchEnd}
//     >
//       {/* ⬅ Blue blur background */}
//       <img
//         src={blurTop}
//         alt="blur"
//         className="absolute top-0 left-0 w-full pointer-events-none select-none"
//       />

//       {/* Main Illustration */}
//       <div className="relative z-10 flex justify-center">
//         <img
//           src={screens[index].img}
//           alt="Onboarding Illustration"
//           className="w-72 h-72 object-contain drop-shadow-md"
//         />
//       </div>

//       {/* Dots */}
//       <div className="relative z-10 flex justify-start space-x-2">
//         {screens.map((_, i) => (
//           <span
//             key={i}
//             className={`w-3 h-3 rounded-full transition-all ${
//               i === index ? "bg-blue-600" : "bg-gray-300"
//             }`}
//           ></span>
//         ))}
//       </div>

//       {/* Text */}
//       <div className="relative z-10 text-start">
//         <h1 className="text-2xl font-extrabold text-gray-900">
//           {screens[index].title}
//         </h1>

//         <p className="text-gray-600 mt-3 leading-relaxed text-sm">
//           {screens[index].desc}
//         </p>
//       </div>

//       {/* Buttons */}
//       <div className="relative z-10 flex flex-col items-center space-y-4">
//         <button
//           className="text-blue-600 font-medium"
//           onClick={() => setIndex(screens.length - 1)}
//         >
//           Skip
//         </button>

//         <button
//           className="w-full bg-blue-600 text-white py-3 rounded-xl text-lg font-semibold shadow-md"
//           onClick={() => {
//             if (index < screens.length - 1) setIndex(index + 1);
//           }}
//         >
//           {index === screens.length - 1 ? "Get Started" : "Next"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default OnboardingScreen;




import React, { useState } from "react";
import splash1 from "../../assets/splashScreen/OBJECTS.svg";
import splash2 from "../../assets/splashScreen/Group 1.svg";
import splash3 from "../../assets/splashScreen/Group 2.svg";
import blurTop from "../../assets/splashScreen/Blur.svg"
import { useNavigate } from "react-router-dom";
const screens = [
  {
    img: splash1,
    title1: "Smart Payments for a",
    title2: "Smarter Life",
    desc: "Pay bills instantly and securely. One app for all payments simple, fast, and reliable. Pay Easy. Live Bright.",
  },
  {
    img: splash2,
    title1: "Your Secure Digital",
    title2: "Wallet Experience",
    desc: "Save your cards and make secure transactions anywhere.",
  },
  {
    img: splash3,
    title1: "Pay. Track.",
    title2: "Manage Everything",
    desc: "Keep full control of your spending with smart insights.",
  },
];

const SplashAfterScreen = () => {
  const [index, setIndex] = useState(0);
  const navigate =useNavigate()

  let touchStartX = 0;
  let touchEndX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  };

  const handleSwipe = () => {
    if (touchStartX - touchEndX > 50 && index < screens.length - 1) {
      setIndex(index + 1);
    } else if (touchEndX - touchStartX > 50 && index > 0) {
      setIndex(index - 1);
    }
  };

  return (
    <div
      className="relative w-full min-h-screen flex flex-col bg-white overflow-hidden"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      {/* Blue Blur Background */}
      <img
        src={blurTop}
        alt=""
        className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none"
      />

      {/* Content Container (Locks width to nice mobile size) */}
      <div className="flex flex-col flex-1 max-w-sm mx-auto w-full px-6 py-6">

        {/* Top Image Section */}
        <div className="flex-1 flex justify-center items-center mt-4">
          <img
            src={screens[index].img}
            alt=""
            className="w-full max-w-xs max-h-[45vh] object-contain"
          />
        </div>

        {/* Dots */}
        <div className="flex justify-start space-x-2 mb-6">
          {screens.map((_, i) => (
            <span
              key={i}
              className={`w-3 h-3 rounded-full transition-all ${
                i === index ? "bg-blue-600" : "bg-gray-300"
              }`}
            ></span>
          ))}
        </div>

        {/* Text */}
   <div className="text-start">
  <h1 className="text-2xl font-extrabold text-gray-900 leading-snug">
    {screens[index].title1} <br />
    {screens[index].title2}
  </h1>

  <p className="text-gray-600 mt-3 leading-relaxed text-sm">
    {screens[index].desc}
  </p>
</div>

        {/* Buttons */}
        <div className="mt-auto flex flex-col items-center space-y-4 pb-6">
          <button
            className="text-blue-600 font-medium"
            onClick={() => setIndex(screens.length - 1)}
          >
            Skip
          </button>

          <button
            className="w-full bg-blue-600 text-white py-3 rounded-xl text-lg font-semibold shadow-md"
            onClick={() => {
              if (index < screens.length - 1) setIndex(index + 1)
              else {
    navigate("/signup");
  };
            }}
          >
            {index === screens.length - 1 ? "Get Started" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SplashAfterScreen;
